import SupplierContribution from "@app/screens/Contributor/SupplierContribution";
import { RouteObject } from "react-router-dom";

export const contributeRoutes: RouteObject[] = [
    {
        path: "supplier/:questionnaire_id",
        element: <SupplierContribution />,
    },
];
 